/** /messages is admin-only (admin sidebar). */
export function normalizeUserRole(role) {
  return String(role || '').toLowerCase()
}

export function canAccessMessages(role) {
  return normalizeUserRole(role) === 'admin'
}

export function isMessagesHiddenForRole(role) {
  return !canAccessMessages(role)
}

export function getMessagesBlockedRedirect(role) {
  switch (normalizeUserRole(role)) {
    case 'buyer':
      return '/buyer-dashboard'
    case 'seller':
      return '/seller-dashboard'
    case 'broker':
    case 'advisor':
      return '/advisor-dashboard'
    case 'smb':
      return '/crm'
    default:
      return '/'
  }
}

/** Roles that can open /browse-opportunities */
const BROWSE_OPPORTUNITIES_ROLES = new Set(['admin', 'buyer', 'deal_sourcer'])

export function canAccessBrowseOpportunities(role) {
  return BROWSE_OPPORTUNITIES_ROLES.has(normalizeUserRole(role))
}

export function isBrowseOpportunitiesHiddenForRole(role) {
  return !canAccessBrowseOpportunities(role)
}
